/**
 * Stack of HtmlElement Objects
 */
export default class HtmlElementsStack {
  constructor(...htmlElements) {
    this.stack = [];
    this.attach(...htmlElements);
  }

  /**
   * pushes new objects on to the stack
   * @param htmlElements
   */
  attach(...htmlElements) {
    htmlElements.forEach((htmlElement) => {
      if (htmlElement.exists()) {
        this.stack.push(htmlElement);
      }
    });
  }

  /**
   * call function by name on every element in stack if it exists
   * @param fnName Name of function to be called
   * @param args Potential arguments for fnName
   */
  forEachCallFunction(fnName, ...args) {
    this.stack.forEach((htmlElement) => {
      if (typeof htmlElement[fnName] === "function") {
        htmlElement[fnName].call(htmlElement, ...args);
      }
    })
  }
}
